// extracted by mini-css-extract-plugin
module.exports = {"content":"MenuContent_content__2Fl51"};